import authService from '@/services/auth';
import { PROFILE } from '@/constants/routes';

export default function checkAuth() {
  const hasAuthTokens = authService.hasAuthTokens();
  if (hasAuthTokens) return { name: PROFILE };
  return true;
}
